<template>
  <Pill
    v-if="!isSwedish"
    class="mb-4 text-break"
    color="white-blue"
  >
    <template #default>
      <slot v-bind="{ lang: $t('currentLanguage') }">
        <span data-i18n="someReviewsMachineTranslatedTo">
          {{ $t('someReviewsMachineTranslatedTo') }}&nbsp;
        </span>
        <span
          class="lowercase"
          data-i18n="currentLanguage"
        >{{ $t('currentLanguage') }}</span>
      </slot>
    </template>
    <template #icon>
      <i-flag-swe
        filled
        :font-controlled="false"
        width="16"
        height="16"
        alt="Sweden"
      />
    </template>
  </Pill>
</template>

<script>
import { mapState } from 'pinia'

export default defineNuxtComponent({
  computed: {
    ...mapState(useLocaleStore, ['isSwedish']),
  },
})
</script>
